function humanizeMessage(msg: string): string {
  if (/String should have at least \d+ character/.test(msg)) {
    const n = msg.match(/\d+/)?.[0];
    return n ? `Must be at least ${n} characters` : msg;
  }
  if (/String should have at most \d+ character/.test(msg)) {
    const n = msg.match(/\d+/)?.[0];
    return n ? `Must be at most ${n} characters` : msg;
  }
  if (/ensure this value has at least \d+ character/.test(msg)) {
    const n = msg.match(/\d+/)?.[0];
    return n ? `Must be at least ${n} characters` : msg;
  }
  return msg;
}

export const formatStepError = (err: any, fallback: string) => {
  const data = err?.response?.data;
  const detail = data?.detail;
  if (typeof detail === 'string') return humanizeMessage(detail);
  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => (typeof item?.msg === 'string' ? humanizeMessage(item.msg) : JSON.stringify(item)))
      .filter(Boolean);
    if (messages.length) return messages.join(', ');
  }
  if (detail && typeof detail === 'object') {
    if (typeof detail.msg === 'string') return humanizeMessage(detail.msg);
    return JSON.stringify(detail);
  }
  if (typeof data?.message === 'string') return humanizeMessage(data.message);
  return err?.message || fallback;
};
